import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Button } from "@mui/material";
import { useMemo, useState } from "react";
import type { ConditionField, DimensionDescriptor } from "../../../../../../../../api/types/svTypes.ts";
import { useBiCommonDataContext } from "../../../../contexts/BiCommonDataContext.ts";
import DimensionSelection from "../DimensionSelection.tsx";

interface Props {
  dimensions: DimensionDescriptor[];
  conditions: ConditionField[];
  addCondition: (values: DimensionDescriptor) => void;
}

const AddCustomConditions = ({ dimensions, conditions, addCondition }: Props) => {
  const { dimensionsStructure } = useBiCommonDataContext();

  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
  const [menuWidth, setMenuWidth] = useState(0);

  const fieldsForConditions = useMemo(() => {
    return dimensions.filter((f) => !conditions.some((c) => c.meta.name === f.name));
  }, [dimensions, conditions]);

  return (
    <>
      <Button
        color="inherit"
        fullWidth
        disableRipple
        sx={{
          justifyContent: "flex-start",
          px: 2,
          py: 0.75,
          fontWeight: "fontWeightRegular",
        }}
        startIcon={<AddRoundedIcon color="secondary" />}
        onClick={(e) => {
          setMenuAnchorEl(e.currentTarget);
          setMenuWidth(e.currentTarget.offsetWidth);
        }}
      >
        Add Condition
      </Button>
      {menuAnchorEl && (
        <DimensionSelection
          anchorEl={menuAnchorEl}
          dimensions={fieldsForConditions}
          onClose={(value) => {
            if (value !== undefined) {
              addCondition(value);
            }
            setMenuAnchorEl(null);
          }}
          menuWidth={menuWidth}
          dimensionsStructure={dimensionsStructure ?? { groups: [], dimensions: [] }}
        />
      )}
    </>
  );
};
export default AddCustomConditions;
